<template>
  <transition name="slide-y-transition" mode="out-in">
    <div class="table table_middle" v-if="items.length">
      <modal></modal>
      <table :class="{drag: drag}">
        <thead>
        <tr>
          <!--<icon-arrowup/>-->
          <th class="caption">Название статьи<span class="table_move"></span></th>
          <th class="middle">Автор<span class="table_move"></span></th>
          <th class="middle little">Видимость</th>
          <th class="icons"></th>
        </tr>
        </thead>
        <draggable v-model="dragItems"
                   v-bind="dragOptions"
                   @start="drag = true"
                   @end="draggableEnd($event)"
                   tag="tbody">
          <tr v-for="(item, index) in items" v-bind:key="item.id" :data-id="index" class="list-group-item">
          <router-link :to="`/library/recommended-films/${item.id}/edit`" class="table-link caption link">
            <span>{{item.title}}</span>
          </router-link>
          <td class="middle no-wrap">
            <span>{{getAuthor(item.author_id)}}</span>
          </td>
          <td class="middle little">
            <v-switch
              v-model="item.is_active" :color="'#089cd3'"
              @click.capture.stop="toggleActive(item)">
            </v-switch>
          </td>
          <td class="icons">
            <router-link :to="`/library/recommended-films/${item.id}/edit`" class="edit">
              <icon-pencil/>
              <div class="hint left edit">Редактировать</div>
            </router-link>
            <a class="delete-icon" @click.prevent="onDeleteItem(item)">
              <icon-delete/>
              <div class="hint left">Удалить</div>
            </a>
          </td>
        </tr>
        </draggable>
      </table>
    </div>
  </transition>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'
  import IconDelete from '@/components/icons/IconDelete'
  import IconArrowup from '@/components/icons/IconArrowup'
  import IconPencil from '@/components/icons/IconPencil'
  import Modal from '@/components/Modal'

  const {mapActions, mapState, mapMutations} = createNamespacedHelpers('mainPage')

  export default {
    data() {
      return {
        authors: [],
        drag: false
      }
    },
    computed: {
      faPencilAlt () {
        return faPencilAlt
      },
      faTrash () {
        return faTrash
      },
      faLink () {
        return faLink
      },
      apiDomain () {
        return this.$store.state.apiDomain
      },
      siteUrl () {
        return this.$store.state.siteUrl
      },
      parentId () {
        return this.$store.state.parentId
      },
      ...mapState([
        'items',
        'currentParentId'
      ]),
      dragOptions() {
        return {
          animation: 200,
          group: "description",
          disabled: false,
          ghostClass: "ghost"
        };
      },
      dragItems: {
        get() {
          return this.items
        },
        set(value) {
          this.setItems(value)
        }
      }
    },
    methods: {
      ...mapActions([
        'getItems',
        'toggleItem',
        'onEditItem',
        'deleteItem',
        'setNewOrder'
      ]),
      ...mapMutations([
        'setShowModal',
        'setItemForDelete',
        'setItems'
      ]),
      toggleActive(item) {
          item.is_active = !item.is_active;
        this.toggleItem({
          title: item.title,
          isActive: item.is_active,
          id: item.id,
          section_id: this.parentId.library.recommendedFilms,
          url: {
            categoryId: null,
            articleUrl: item.url
          },
          img: item.seo_img,
          subtext: item.subtext
        })
      },
      onDeleteItem (item) {
        this.setItemForDelete({id: item.id, title: item.title, url: 'contents', text: item.text, img: item.img});
        this.setShowModal(true)
      },
      draggableEnd(e) {
        this.drag = false
        let item = this.items[e.item.getAttribute('data-id')];
        let index = item.ord;
        if (e.newIndex > e.oldIndex) {
          index -= (e.newIndex - e.oldIndex);
        } else {
          index += (e.oldIndex - e.newIndex);
        }
        this.setNewOrder({
          id: item.id,
          order: index
        })
      },
      getAuthor(id) {
        for (let author of this.authors) {
          if (id === author.id) {
            return author.title
          }
        }
      },
    },
    created() {
      this.$http.get(`${this.$store.state.apiUrls.content}?searchFields=parent_id&search=${this.$store.state.parentId.authors}`)
        .then((response) => {
          if (response.data.data) {
            this.authors = response.data.data
          }
        })
    },
    components: {
      IconDelete,
      IconPencil,
      IconArrowup,
      Modal
    }
  }
</script>

<style scoped>
  td.no-wrap span {
    white-space: nowrap;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
  {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/library/recommended-films/MainTable.vue